import {
  CurrencyPickerControl,
  type CurrencyPickerControlProps,
} from '@/components/currency/CurrencyPickerControl';

export interface CurrencyPickerProps extends Pick<
  CurrencyPickerControlProps,
  'value' | 'onChange' | 'isDisabled' | 'size'
> {
  label: string;
  hint?: string;
}

/**
 * Labeled currency field for the workspace default-currency setting. Thin
 * wrapper over the shared CurrencyPickerControl, which renders the label and
 * hint natively (it's a Select.ComboBox under the hood).
 */
export function CurrencyPicker({
  value,
  onChange,
  label,
  hint,
  isDisabled = false,
  size = 'sm',
}: CurrencyPickerProps) {
  return (
    <CurrencyPickerControl
      value={value}
      onChange={onChange}
      ariaLabel={label}
      label={label}
      hint={hint}
      isDisabled={isDisabled}
      size={size}
    />
  );
}
